import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trophy, Settings, Grid3X3, Infinity, Smartphone } from 'lucide-react';

const Experience = () => {
  const { t } = useTranslation();

  const cards = [
    {
      icon: Trophy,
      title: t('experience.hero.title'),
      description: t('experience.hero.description'),
      color: 'red'
    },
    {
      icon: Settings,
      title: t('experience.features.title'),
      description: t('experience.features.description'),
      color: 'purple'
    },
    {
      icon: Grid3X3,
      title: t('experience.genres.title'),
      description: t('experience.genres.description'),
      color: 'blue'
    },
    {
      icon: Infinity,
      title: t('experience.unlimited.title'),
      description: t('experience.unlimited.description'),
      color: 'green'
    },
    {
      icon: Smartphone,
      title: t('experience.mobile.title'),
      description: t('experience.mobile.description'),
      color: 'orange'
    }
  ];

  const colorClasses = {
    red: 'from-red-500 to-red-700',
    purple: 'from-purple-500 to-purple-700',
    blue: 'from-blue-500 to-blue-700',
    green: 'from-green-500 to-green-700',
    orange: 'from-orange-500 to-orange-700'
  };

  return (
    <section className="py-20 md:py-32 relative">
      {/* Background */}
      <div className="absolute inset-0 grid-pattern opacity-50" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
            <span className="gaming-gradient-text">{t('experience.title')}</span>
          </h2>
        </div>

        {/* Cards grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`gaming-card p-6 rounded-2xl transition-all duration-300 ${
                index === 0 ? 'sm:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${colorClasses[card.color]} flex items-center justify-center mb-5`}>
                <card.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold mb-2">{card.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
